// extracted by mini-css-extract-plugin
export default {"container":"style_container__Sk3UH","iconWrapper":"style_iconWrapper__GPKzy","icon":"style_icon__R+IP3","text":"style_text__H+7zO"};